


























































































import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

import * as c_Interface from '@/interface/components/manageGroups';
import * as s_Interface from '@/interface/store/manageGroups';

const namespace: string = 'manageGroup';

@Component
export default class Settings extends Vue {
  @PropSync('dialogVisible', { type: Boolean }) syncedDialogVisible!: boolean;

  @Action('getSettings', { namespace }) c_getSettings!: any;
  @Action('updateSettings', { namespace }) c_updateSettings!: any;
  @Action('deleteGroup', { namespace }) c_deleteGroup!: any;

  @Action('getGrants', { namespace }) c_getGrants!: any;
  @Action('setGrant', { namespace }) c_setGrant!: any;
  @Action('deleteGrant', { namespace }) c_deleteGrant!: any;
  @Action('getMe', { namespace }) c_getMe!: any;

  @Getter('getterSettings', { namespace }) c_getterSettings!: s_Interface.SettingResponse;
  @Getter('getterMe', { namespace }) c_getterMe!: s_Interface.GroupItem;
  @Getter('getterGrants', { namespace }) c_getterGrants!: any;

  public ruleForm: c_Interface.SettingPayload = {
    name: '',
    organization: '',
    inventoryEdit: 'ALL_EDIT',
    newRequests: [],
  };
  public fkGroupMemberships: Array<string> = [];
  public checkList: Array<string> = [];
  public rules: any = {
    name: [{ required: true, message: 'LAB 이름은 필수 입력사항입니다.', trigger: 'blur' }],
    organization: [
      { required: true, message: '회사명(조직)은 필수 입력사항입니다.', trigger: 'blur' },
    ],
    inventoryEdit: { trigger: 'blur' },
    newRequests: { trigger: 'blur' },
  };
  public dynamicTags: any = [];
  public inputVisible = false;
  public inputValue = '';

  get labName(): string {
    return this.ruleForm.name;
  }

  set labName(v: string) {
    this.ruleForm.name = v;
  }

  get organizationName(): string {
    return this.ruleForm.organization;
  }

  set organizationName(v: string) {
    this.ruleForm.organization = v;
  }

  get inventoryEdit(): string {
    return this.ruleForm.inventoryEdit;
  }

  set inventoryEdit(v: string) {
    this.ruleForm.inventoryEdit = v;
  }

  async created() {
    const groupId: string = this.$route.params.groupId;
    try {
      await this.c_getSettings(groupId);
      await this.c_getGrants(groupId);
      Object.assign(this.ruleForm, {
        name: this.c_getterSettings.name,
        organization: this.c_getterSettings.organization,
        inventoryEdit: this.c_getterSettings.settings.inventoryEdit,
        newRequests: [],
      });
      Object.assign(this.fkGroupMemberships, this.c_getterSettings.fkGroupMemberships);
      if (this.c_getterGrants) {
        this.dynamicTags = this.c_getterGrants;
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  @Watch('$route.params.groupId')
  async onGroupIdChange(groupId: string, oldGroupId: string) {
    try {
      await this.c_getMe(groupId);
      await this.c_getSettings(groupId);
      await this.c_getGrants(groupId);
      Object.assign(this.ruleForm, {
        name: this.c_getterSettings.name,
        organization: this.c_getterSettings.organization,
        inventoryEdit: this.c_getterSettings.settings.inventoryEdit,
        newRequests: [],
      });
      Object.assign(this.fkGroupMemberships, this.c_getterSettings.fkGroupMemberships);
      if (this.c_getterGrants) {
        this.dynamicTags = this.c_getterGrants;
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  newRequests() {
    return (this.ruleForm.newRequests = this.checkList);
  }

  async saveSettings(): Promise<any> {
    (this.$refs['ruleForm'] as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await this.c_updateSettings({
            groupId: this.$route.params.groupId,
            payload: this.ruleForm,
          });
          this.$message.success('LAB 설정을 변경하였습니다.');
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('필수 입력사항 중 입력되지 않은 것이 있습니다.');
      }
    });
  }

  goMember() {
    this.$router.push({
      name: 'Members',
    });
  }

  async handleClose(index: number, grantId: string) {
    if (grantId) {
      try {
        await this.c_deleteGrant({
          groupId: this.$route.params.groupId,
          grantId,
        });
        this.dynamicTags.splice(index, 1);
      } catch (e) {
        console.log(e);
        this.$message.error(e.response.data.error.message);
      }
    }
  }

  showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
    });
  }

  async handleInputConfirm() {
    let inputValue = this.inputValue;
    const dupCheck = this.c_getterGrants.find((grant: any) => grant.name === inputValue);
    if (!dupCheck && inputValue) {
      const data = await this.c_setGrant({
        groupId: this.$route.params.groupId,
        payload: {
          name: inputValue,
        },
      });
      this.dynamicTags.push(data);
    }
    this.inputVisible = false;
    this.inputValue = '';
  }

  async deleteLab(): Promise<any> {
    this.syncedDialogVisible = true;
    this.$prompt(
      `랩을 한번 삭제하면 <span style="font-weight: bold;">다시 복구할 수 없습니다.</span><br/>
        모든 물품정보 및 구매주문 정보가 삭제됩니다.<br/>
        삭제하시기 전에 필요한 정보는 백업을 하시기 바랍니다.<br/>
        LAB 이름 : <span style="font-weight: bold;">${this.c_getterSettings.name}</span>`,
      'LAB을 삭제하시겠습니까?',
      {
        center: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'LAB 삭제하기',
        cancelButtonText: '취소',
        closeOnPressEscape: false,
        inputPlaceholder: '랩 이름을 정확히 입력해주세요.',
        confirmButtonClass: 'redBorderColorBtn',
      }
    )
      .then(async ({ value }: any) => {
        this.syncedDialogVisible = false;
        if (this.labName === value) {
          try {
            await this.c_deleteGroup({
              groupId: this.$route.params.groupId,
            });
            await this.$router.push({
              name: 'Container',
              params: {
                groupId: 'welcome',
              },
            });
            this.$message.success('LAB을 삭제 하였습니다.');
          } catch (e) {
            console.log(e);
            this.$message.error(e.response.data.error.message);
          }
        } else {
          this.$message.error('LAB 이름이 일치하지 않습니다.');
        }
      })
      .catch((e) => {
        this.syncedDialogVisible = false;
        console.log(e);
      });
  }
}
